export default __webpack_public_path__ + "static/media/star_appnge.13f8f1b5.png";